import { FunctionComponent } from "react";
import { useStatistiquesContext, ViewMode } from "./statistiquesContext";
import { Box, Button, ButtonGroup, FormControlLabel, Switch, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import ChairIcon from "@mui/icons-material/Chair";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { RefreshButton } from "../../components/commons/RefreshButton";

export const StatistiquePageHeader: FunctionComponent = () => {
    const {
        currentView,
        setCurrentView,
        reset,
        ens,
        setEns,
        invalidateQueries,
    } = useStatistiquesContext();

    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={"0.5rem"} justifyContent="flex-start" padding={2}>
            <Typography variant="h4">
                Statistiques
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="flex-start" width="100%">
                <ToggleButtonGroup
                    exclusive
                    value={currentView}
                    onChange={(_, newView) => {
                        if (!newView) return;
                        setCurrentView(newView)
                    }}
                    size={"small"}
                >
                    <ToggleButton value={ViewMode.STORE}>
                        <ChairIcon />
                        <span style={{ marginLeft: 8 }}>Produits</span>
                    </ToggleButton>
                    <ToggleButton value={ViewMode.PRODUCT}>
                        <StorefrontIcon />
                        <span style={{ marginLeft: 8 }}>Magasins</span>
                    </ToggleButton>
                </ToggleButtonGroup>
                <Box display="flex" alignItems="center" gap="1rem" justifyContent="space-evenly">
                    <FormControlLabel
                        control={
                            <Switch
                                size="medium"
                                onChange={(_, checked) => {
                                    setEns(checked);
                                }}
                            />
                        }
                        checked={ens}
                        label="Ensemble"
                        labelPlacement="start"
                    />
                    <ButtonGroup size="small" variant="outlined">
                        <Button
                            size="small"
                            color="primary"
                            variant="contained"
                            onClick={() => reset()}
                            sx={{
                                borderRadius: "30px",
                            }}
                        >
                            Réinitialiser
                        </Button>
                    </ButtonGroup>
                    <RefreshButton
                        invalidateQueries={() => {
                            invalidateQueries();
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default StatistiquePageHeader;